import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/ui-kit";
import { CalendarRange, Utensils, Moon, Bath, Smile } from "lucide-react";

const DOT = { Present: "bg-emerald-500", Late: "bg-amber-500", Absent: "bg-rose-500", Leave: "bg-sky-500" };
const COLS = [["food_intake", Utensils], ["nap_time", Moon], ["washroom", Bath], ["behavior", Smile]];
const DAY = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function WeekReviewCard({ student }) {
  const [w, setW] = useState(null);
  const isWeekend = [0, 6].includes(new Date().getDay());
  useEffect(() => {
    if (isWeekend) { api.get("/week-review", { params: { student_id: student.id } }).then((r) => setW(r.data)).catch(() => setW(null)); }
  }, [student.id, isWeekend]);
  if (!w) return null;
  return (
    <div data-testid="week-review-card" className="rounded-2xl border border-violet-100 bg-gradient-to-br from-violet-50 to-white p-4 mb-4">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="font-display font-bold text-slate-900 flex items-center gap-2"><CalendarRange size={17} className="text-violet-600" />Week in review · {fmtDate(w.week_start)} – {fmtDate(w.week_end)}</div>
        <span data-testid="week-review-summary" className="text-xs font-semibold text-violet-700 bg-violet-100 px-2.5 py-1 rounded-full">Present {w.present}/{w.marked} · activity {w.logged} days</span>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {w.days.map((d, i) => (
          <div key={d.date} data-testid={`week-day-${d.date}`} className="rounded-xl bg-white border border-slate-100 p-2 text-xs">
            <div className="flex items-center justify-between font-semibold text-slate-800">{DAY[i]}<span title={d.attendance || "Not marked"} className={`h-2.5 w-2.5 rounded-full ${DOT[d.attendance] || "bg-slate-200"}`} /></div>
            <div className="mt-1.5 space-y-1">
              {COLS.filter(([k]) => d[k]).map(([k, Icon]) => <div key={k} className="flex gap-1 text-slate-600"><Icon size={11} className="mt-0.5 shrink-0 text-violet-500" /><span className="line-clamp-1">{d[k]}</span></div>)}
              {!COLS.some(([k]) => d[k]) && <div className="text-slate-400">—</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
